const DRAG_THRESHOLD = 5;

class HeroSalut extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.hero-salut__grid');
    this.dots = Array.from(this.querySelectorAll('.hero-salut__dot'));
    if (!this.track || this.dots.length === 0) return;

    this.slides = Array.from(this.track.children);
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.track.scrollTo({ left: this.slides[index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      });
    });

    this.onScroll = this.onScroll.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();

    this.enableDragging();
  }

  disconnectedCallback() {
    if (this.track) this.track.removeEventListener('scroll', this.onScroll);
  }

  enableDragging() {
    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let moved = 0;

    // Capturarea pointerului trimite si click-ul catre track, nu catre elementul
    // de sub cursor, asa ca linkurile din banere nu mai navigau deloc. Se captureaza
    // abia cand miscarea trece de prag, adica atunci cand chiar e drag, nu clic.
    let captured = false;

    this.track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = this.track.scrollLeft;
      moved = 0;
      captured = false;
    });

    this.track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const delta = event.clientX - startX;
      moved = Math.max(moved, Math.abs(delta));
      if (!captured && moved > DRAG_THRESHOLD) {
        this.track.setPointerCapture(pointerId);
        this.track.classList.add('is-dragging');
        captured = true;
      }
      if (!captured) return;
      this.track.scrollLeft = startScroll - delta;
      event.preventDefault();
    });

    const end = (event) => {
      if (event.pointerId !== pointerId) return;
      if (captured) {
        this.track.releasePointerCapture(pointerId);
        this.track.classList.remove('is-dragging');
        this.snapToNearest();
      }
      pointerId = null;
      captured = false;
    };

    this.track.addEventListener('pointerup', end);
    this.track.addEventListener('pointercancel', end);
    this.track.addEventListener('click', (event) => {
      if (moved > DRAG_THRESHOLD) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

  snapToNearest() {
    const middle = this.track.scrollLeft + this.track.clientWidth / 2;
    let nearest = this.slides[0];
    this.slides.forEach((slide) => {
      const center = slide.offsetLeft - this.track.offsetLeft + slide.clientWidth / 2;
      const bestCenter = nearest.offsetLeft - this.track.offsetLeft + nearest.clientWidth / 2;
      if (Math.abs(center - middle) < Math.abs(bestCenter - middle)) nearest = slide;
    });
    this.track.scrollTo({ left: nearest.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
  }

  onScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      const middle = this.track.scrollLeft + this.track.clientWidth / 2;
      let active = 0;
      this.slides.forEach((slide, index) => {
        if (slide.offsetLeft - this.track.offsetLeft <= middle) active = index;
      });
      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
    });
  }
}

if (!customElements.get('hero-salut')) customElements.define('hero-salut', HeroSalut);
